import { InteractionStatus } from '@azure/msal-browser';
import { useAccount, useMsal } from '@azure/msal-react';
import { PropsWithChildren, useEffect } from 'react';

import { mapToADUser } from 'domain/user/User';
import { setADUser } from 'library/redux/application';
import { useAppDispatch } from 'library/redux/hooks';

import { clearMsalAuthenticationRetry } from './MsalAuthenticationRetry';

export const MsalAccountSetting = ({
	children,
	onMsalChanged,
}: PropsWithChildren<{
	onMsalChanged: (isInitialized: boolean) => void;
}>) => {
	const dispatch = useAppDispatch();
	const { instance, accounts, inProgress } = useMsal();
	const account = useAccount(
		instance.getActiveAccount() ?? accounts[0] ?? {}
	);

	useEffect(() => {
		if (account && inProgress === InteractionStatus.None) {
			instance.setActiveAccount(account);
			clearMsalAuthenticationRetry();
			dispatch(setADUser(mapToADUser(account)));
			onMsalChanged(!!account);
		}
	}, [account, dispatch, instance, onMsalChanged, inProgress]);

	return children;
};
